import React from 'react';
import { useTranslation } from 'react-i18next';
import { InitialSignInButton } from './styled';

export const InitialLoginButton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <InitialSignInButton className="link">
      <span>{t('common.login')}</span>
    </InitialSignInButton>
  );
};
